<div #aceeditor class="code-editor"></div>